export default "__VITE_ASSET__83c790ef__"